import { ONBOARDING_PARTICIPANT_ROLES } from "../components/shared/config";

export const getOnboardingDetailsIdFromLocation = () => {
  const queryParams = new URLSearchParams(
    typeof location !== "undefined" ? location.search : ""
  );
  return queryParams.get("oid") || queryParams.get("id") || undefined;
};

export const getParticipantRoleByQueryParam = (loan) => {
  let participantRole = undefined;
  const queryParams = new URLSearchParams(location.search);
  const onboardingDetailsId = getOnboardingDetailsIdFromLocation();

  if (!queryParams.has("r") && !onboardingDetailsId)
    return ONBOARDING_PARTICIPANT_ROLES.BORROWER;

  if (onboardingDetailsId && loan) {
    return findParticipantOnboardingDetailsByOnboardingDetailsId(
      loan,
      onboardingDetailsId
    )?.role;
  }

  const getParticipantRoleByQueryParam = (participantRole) => {
    switch (participantRole) {
      case "b":
        return ONBOARDING_PARTICIPANT_ROLES.BORROWER;
      case "c":
        return ONBOARDING_PARTICIPANT_ROLES.CO_BORROWER;
      case "g":
        return ONBOARDING_PARTICIPANT_ROLES.GUARANTOR;
      default:
        return undefined;
    }
  };

  if (queryParams.has("r")) {
    participantRole = getParticipantRoleByQueryParam(
      queryParams.get("r").toLowerCase()
    );
    if (
      !loan.onboarding_details.some(
        (details) => details.role === participantRole
      )
    ) {
      return undefined;
    }
    return participantRole;
  }
};

export const findParticipantOnboardingDetailsByRole = (loan, participantRole) =>
  loan?.onboarding_details.find(
    (onboardingDetail) => onboardingDetail.role === participantRole
  );

export const findParticipantOnboardingDetailsByBorrowerId = (
  loan,
  borrowerId
) => {
  return loan?.onboarding_details.find(
    (details) => details.borrower_id === borrowerId
  );
};

export const findParticipantOnboardingDetailsByOnboardingDetailsId = (
  loan,
  onboardingDetailsId
) => {
  return loan.onboarding_details?.find(
    (details) => details.id === onboardingDetailsId
  );
};

export const getParticipantIdByOnboardingDetailsId = (
  loan,
  onboardingDetailsId
) => {
  return loan?.onboarding_details.find(
    (details) => details.id === onboardingDetailsId
  )?.borrower_id;
};

export const getParticipantIdByRole = (loan, participantRole) => {
  switch (participantRole) {
    case ONBOARDING_PARTICIPANT_ROLES.BORROWER:
      return loan.borrower_id;
    case ONBOARDING_PARTICIPANT_ROLES.CO_BORROWER:
      return loan.co_borrower_id;
    case ONBOARDING_PARTICIPANT_ROLES.GUARANTOR:
      return loan.guarantor_ids?.[0];
    default:
      return undefined;
  }
};
